@use "../../style/mixins" as *;
@use "../../style/variables" as *;

%flex-row {
  display: flex;
  flex-direction: row;
  flex: 1 1 0;
}

%flex-column {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
}


.user-container {

  @extend %flex-row;
  color: $grey-text;
  background-color: #F2F2F2;
  width: 100%;
  height: 14.25rem;
  margin-top: 2rem;

  @include mobile {
    flex-direction: row;
    height: 138px;
    width: 100%;
    margin-top: 0;
    padding-left: 1.10625rem;
    padding-right: 1.1875rem;
  }

  .image-container {
    margin: 1.875rem 1.5rem 1.875rem 1.875rem;

    @include mobile {
      margin-top: auto;
      margin-bottom: auto;
      margin-left: 0;
    }

    .user-image {
      max-height: 170px;
      border-radius: 50%;
      border: 4px solid $grey-light;

      @include mobile {
        width: 6.25rem;
        height: 6.25rem;
        border: 1px solid #707070;

      }
    }
  }

  .details {
    position: relative;
    @extend %flex-column;
    justify-content: center;

    .card-details {
      position: absolute;
      top: 0;
      right: 0;
      text-align: right;
      color: $grey;
      margin-top: 1.8rem;
      margin-right: 1.8rem;
      // fixes card detail height for IE
      height: 8%;

      @include mobile {
        display: none;
      }

      .card-info {
        height: 100%;
        display: flex;
        .card-number {
          margin-left: 0.5rem;
        }

        .icon {
          &.card svg {
            width: 1.25rem;
            height: auto;
          }
        }

        .solid {
          fill: $grey;
          stroke: none
        }
      }

      .card-text {
        color: #888888;
      }
    }

    .user-details {
      display: flex;
      flex-direction: column;

      .username {
        font-size: 1.5rem;
        line-height: 1.5rem;
        font-weight: 700;

        @include mobile {
          font-size: 1rem;
          font-weight: 600;
          line-height: 1.25rem;
          align-self: flex-end;
          position: absolute;
          top: 0;
          right: 0;
          margin-top: 0.75rem;
        }
      }

      .user-email {
        margin-top: 0.125rem;
        font-size: 1.125rem;
        line-height: 1.125rem;
        font-weight: 400;

        @include mobile {
          display: none;
        }
      }
    }

    .user-edit {

      position: absolute;
      top: 9.5rem;

      @include mobile {
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
        margin-left: auto;
        position: static;
      }

      .icon {
        &.editProfile svg {
          width: 1.25rem;
          height: 1.25rem;
          vertical-align: center;
          cursor: pointer;
        }
      }

      .solid {
        fill: #888888;
        stroke: none
      }
    }

    .points-container {
      @extend %flex-row;
      margin-right: 1.75rem;
      align-items: baseline;
      justify-content: flex-end;
      margin-top: auto;
      margin-bottom: 1.375rem;
      // fixes bottom points alignment in profile for IE
      height: 1.9375rem;
      position: absolute;
      bottom: 0;
      right: 0;

      @include mobile {
        flex: 0 0 auto;
        margin-right: 0;
        margin-bottom: 0.375rem;
      }

      .points-label {
        font-size: 1.5rem;
        font-weight: 300;
        line-height: 1.5rem;
        margin-right: 0.25rem;

        @include mobile {
          font-size: 0.75rem;
          line-height: 0.75rem;
        }
      }

      .points-text {
        font-size: 2.375rem;
        line-height: 2.375rem;
        font-weight: bold;

        @include mobile {
          font-size: 1.25rem;
          line-height: 1.25rem;
        }
      }
    }
  }
}
